<script setup lang="ts">
import type { StickerFill } from '../SfgSticker.vue'

/**
 * SfgLightning1 — single-zigzag lightning bolt sticker. Top-to-
 * bottom Z silhouette with one horizontal jog at the bend.
 * Aspect ~5:6 (taller than wide); `size` drives the rendered
 * height and width follows proportionally.
 */

const props = withDefaults(defineProps<{
  border?: StickerFill
  fill?: StickerFill
  size?: number | string
  tilt?: number
}>(), {
  border: 'ink',
  fill: 'yellow',
  size: 70,
  tilt: -10,
})

const heightCss = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
const widthCss = computed(() => {
  if (typeof props.size === 'number') {
    return `${props.size * (100 / 120)}px`
  }
  return `calc(${props.size} * ${100 / 120})`
})
const fillVar = computed(() => `var(--color-brand-${props.fill})`)
const strokeVar = computed(() => `var(--color-brand-${props.border})`)
</script>

<template>
  <svg
    aria-hidden="true"
    :style="{
      width: widthCss,
      height: heightCss,
      transform: `rotate(${tilt}deg)`,
      filter: 'drop-shadow(0 3px 0 rgba(0, 0, 0, 0.6))',
    }"
    viewBox="0 0 100 120"
  >
    <path
      d="M55 5 L15 60 L40 60 L25 115 L75 50 L48 50 Z"
      :fill="fillVar"
      :stroke="strokeVar"
      stroke-width="4"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
  </svg>
</template>
